// Copyright (C) 2017-2022 Smart code 203358507

const React = require('react');

const RouteFocusedContext = React.createContext(false);

RouteFocusedContext.displayName = 'RouteFocusedContext';

module.exports = RouteFocusedContext;
